import type { UserMessages } from '../types';

const messages: UserMessages = {
  'user.login.password.required': '请输入密码',
  'user.login.password.required.placeholder': '输入密码',
  'user.loginOrRegister.email': '邮箱',
  'user.loginOrRegister.captcha.placeholder': '验证码',
  'user.loginOrRegister.captcha.sendEmail': '获取邮箱验证码',
  'user.loginOrRegister.rule.required.captcha': '请输入验证码',
  'user.loginOrRegister.rule.required.mail': '请输入邮箱',
  'user.loginOrRegister.rule.pattern.mail': '请输入正确的邮箱格式',
  'user.login.password.error': '密码错误，请重试！',
  'user.login.password.tooManyErrors': '您输入密码错误次数过多，请稍后再试。',
  'user.request.message.rateLimit': '请求过于频繁，限制访问，稍后再试',
  'user.login.message.invalidCaptcha': '验证码错误',
  'user.login.message.invalidCaptcha.tip': '验证码错误，请重试',
} as const;

export default messages;
